import $ from 'jquery'

// Handle video autoplay in popup
$(document).ready(function() {
  // Handle video modal opening with Magnific Popup callbacks
  $(document).on('click', '.js-open-video-modal', function() {
    const target = $(this).attr('href');
    const video = $(target).find('video');
    
    if (video.length) {
      // Set up callback for when popup opens
      $.magnificPopup.open({
        items: {
          src: target,
          type: 'inline',
        },
        callbacks: {
          open: function() {
            // Play video when popup opens
            const popupVideo = $(this.content).find('video');
            if (popupVideo.length) {
              popupVideo[0].play();
            }
          },
          close: function() {
            // Pause video when popup closes
            const popupVideo = $(this.content).find('video');
            if (popupVideo.length) {
              popupVideo[0].pause();
              popupVideo[0].currentTime = 0; // Reset to beginning
            }
          }
        },
        closeBtnInside: true
      });
    }
  });
});
